import type { CapabilityOverride } from "@/services/capabilitiesApi";

export type CronBadgeKind = "off" | "dormant" | "on" | "pending" | "error";

function isDenied(
  global: CapabilityOverride | null,
  bySource: Map<string, CapabilityOverride>,
  sourceId: string,
): { denied: boolean; globally: boolean } {
  if (global?.state === "deny") {
    return { denied: true, globally: true };
  }
  if (bySource.get(sourceId)?.state === "deny") {
    return { denied: true, globally: false };
  }
  return { denied: false, globally: false };
}

export function cronBadgeKind(args: {
  global: CapabilityOverride | null;
  bySource: Map<string, CapabilityOverride>;
  sourceId: string;
  cronEnabled: boolean | undefined;
  cronPending: boolean;
  overridesPending?: boolean;
  overridesError?: boolean;
}): { kind: CronBadgeKind; title: string } {
  if (args.overridesError) {
    return {
      kind: "error",
      title: "Could not load scraper.cron capability overrides.",
    };
  }

  if (args.overridesPending) {
    return {
      kind: "pending",
      title: "Loading scraper.cron capability overrides…",
    };
  }

  const denied = isDenied(args.global, args.bySource, args.sourceId);
  if (denied.denied) {
    return {
      kind: "off",
      title: denied.globally
        ? "Cron is denied globally."
        : "Cron is denied for this source.",
    };
  }

  if (args.cronPending && args.cronEnabled === undefined) {
    return {
      kind: "pending",
      title: "Checking whether cron scheduling is enabled in this environment…",
    };
  }

  if (args.cronEnabled === false) {
    return {
      kind: "dormant",
      title: "",
    };
  }

  return {
    kind: "on",
    title: "Cron scheduling is on. This source will be picked up.",
  };
}
